import { useLocation } from "react-router-dom";
import Seo from "../Components/Seo";
import { staticSeoByPath } from "../config/staticSeo";

const PageSeo = () => {
  const { pathname } = useLocation();
  const entry = staticSeoByPath[pathname];

  if (!entry) return null;

  return (
    <Seo
      title={entry.title}
      description={entry.description}
      ogTitle={entry.ogTitle}
      ogDescription={entry.ogDescription}
      keywords={entry.keywords}
      path={entry.path}
      image={entry.image}
      ogType={entry.ogType}
      ogImageType={entry.ogImageType}
      ogImageWidth={entry.ogImageWidth}
      ogImageHeight={entry.ogImageHeight}
      siteName={entry.siteName}
      locale={entry.locale}
      localeAlternate={entry.localeAlternate}
      articlePublisher={entry.articlePublisher}
      robots={entry.robots}
      author={entry.author}
      publisher={entry.publisher}
      themeColor={entry.themeColor}
      htmlLang={entry.htmlLang}
      twitterSite={entry.twitterSite}
      twitterCreator={entry.twitterCreator}
      alternates={entry.alternates}
      iconHref={entry.iconHref}
      appleTouchIconHref={entry.appleTouchIconHref}
      jsonLd={entry.jsonLd}
      fbAppId={entry.fbAppId}
    />
  );
};

export default PageSeo;
